//messages.js
export default {
    sensor_type: "Sensor Type",
    sensor_description: "Sensor Description",
    measurement_symbol: "Measurement Symbol",
    imperial_symbol: "Imperial Symbol",
    metric_symbol: "Metric Symbol",
    round_precision: "Round Precision",
};
